export default __webpack_public_path__ + "static/media/enterprisePlanWhiteLogo.bff32e8e.svg";